import Api from "./Api";

const keepAliveInterval = 60000;

class KeepAlive {

    static instance = null;

    timerId = -1;

    constructor() {

        // console.debug("Created new Keepalive-Instance");
        this.api = new Api();

    }

    /**
     *
     * @returns {KeepAlive}
     */
    static getInstance() {

        if (!KeepAlive.instance)
            KeepAlive.instance = new KeepAlive();

        return KeepAlive.instance;

    }

    start(callback, errorCallback) {

        this.timerId = window.setInterval(() => this.sendKeepAlive(callback, errorCallback), keepAliveInterval);

    }

    stop() {

        window.clearInterval(this.timerId);

    }

    sendKeepAlive(callback, errorCallback) {

        if (!callback)
            callback = this.defaultCallback;

        if (!errorCallback)
            errorCallback = this.defaultErrorCallback;

        // console.debug("keepalive");

        this.api.request('KeepAlive', null, callback, errorCallback);

    }

    defaultCallback(ret) {

        //console.log("keepAlive defaultCallback", ret);

    }

    defaultErrorCallback(ret) {

        console.error("keepAlive defaultErrorCallback", ret);

    }

}

export default KeepAlive;